<template>
  <div class="main-inner-blk">
    <v-card class="assign-filter-blk" elevation="3">
      <!-- :placeHolder="'Search ID/Crew Name/Crew ID/Mobile/Flight No'" -->
      <Filters
        @get-filter="getFilters"
        :filterData="'toBeAssigned'"
        :tripList="tripList"
  :placeHolder="computedPlaceholder"
        :tripType="tripType"
        :dateRange="true" 
        type="tripsList"
        :tab="tab"
        ref="filters"
      ></Filters>
      <v-btn v-if="tripType === 0 || tripType === 1" class="export-btn" color="primary" small @click="exportToExcel" :disabled="isExportDisabled"> Export to Excel </v-btn>
    </v-card>
    <div class="trip-list-blk" ref="tripList">
      <div v-if="tripList.length > 0">
        <div class="trip-list-header-blk" :class="{ 'cancellation-block': tripType !== 1 }">
          <!-- <span class="sl-no-blk header-content-blk">Sl No</span> -->
          <span class="id-blk header-content-blk"> Trip ID</span>
          <span class="user-blk header-content-blk" v-if="isIndigo === 'false'">Employee Details</span>
          <!-- <span class="corporate-blk header-content-blk" v-if="!isIndigo">Corporate</span> -->
          <span class="header-content-blk location-blk" v-if="isIndigo === 'false'">Pickup Address</span>
          <span class="header-content-blk location-blk" v-if="isIndigo === 'false'">Drop Address</span>

          <span class="time-blk header-content-blk" v-if="isIndigo === 'false'">Scheduled Time</span>
          <span class="time-blk header-content-blk" v-if="isIndigo === 'false'">Shift Time</span>
          <!-- <span class="category-blk header-content-blk" v-if="isIndigo==='false'">Category</span> -->
          <div v-if="isIndigo === 'true'" class="header-content-blk row-list-blk">
            <div class="row-list">
              <span class="row-list-header" v-if="isIndigo === 'true'">Crew Details</span>
              <span class="row-list-header" v-if="isIndigo === 'true'">Pickup Address</span>
              <span class="row-list-header" v-if="isIndigo === 'true'">Drop Address</span>
              <span class="row-list-header time-column" v-if="isIndigo === 'true'">Drop Off Time</span>
              <span class="row-list-header time-column" v-if="isIndigo === 'true'">Reporting Time</span>
              <span class="row-list-header" v-if="isIndigo === 'true'">SI Comment</span>
            </div>
          </div>
          
          <span class="driver-blk" v-if="tripType === 1">Driver</span>
          <span class="reject-blk" v-if="!isIndigo">Copy</span>
          <span class="header-content-blk time-blk" v-if="isIndigo && [0, 1].includes(tripType)">Status</span>
          <div class="action-blk" v-if="[0, 2].includes(tripType)">Actions</div>
        </div>
        <div class="trip-content-blk" v-for="(data, index) in tripList" :key="index" :class="{ 'cancellation-block': tripType !== 1 }" :style="{ backgroundColor: getStatusColor(data.colorStatus) }">
          <!-- <span class="sl-no-blk list-content-blk">{{ index + 1 }} </span> -->
          <div class="id-blk list-content-blk id-content-blk">
            <strong @click="showDetails(data.bigId)" :class="{ 'bigid-blk': !data.id }">{{ data.id ? data.id : data.bigId }}</strong>
            <span v-if="[1, 2].includes(data.serviceType)">{{ data.serviceType === 1 ? "Pickup" : "DropOff" }}</span>
                <span v-if="[1, 2].includes(data.serviceType) && !isIndigo">{{ data.serviceType === 1 ? "Login" : "Logout" }}</span>
          </div>
          <div class="user-blk content-blk list-content-blk" v-if="isIndigo === 'false'">
            <ul class="assign-employee-list" v-if="[1, 2].includes(data.serviceType)">
              <li v-for="(item, employeeIndex) in data.employees" :key="employeeIndex">
                <span>{{ item.name }} - {{ item.mobile }}</span
                ><br />

              </li>
            </ul>

            <div v-else>
              <span>{{ data.user }} </span><br />
              <span class="">{{ data.mobile }}</span>
            </div>
          </div>
          <!-- <div class="corporate-blk content-blk list-content-blk" v-if="!isIndigo">
       <span>{{ data.corporate }}</span>
       <span>{{ data.branch }}</span>
       <span v-if="data.etsDetails" class="marshal-row">{{ data.etsDetails.hasMarshal === 0 ? "No" : "" }} Marshal Required</span>
      </div> -->

          <div class="content-blk list-content-blk location-blk" v-if="isIndigo === 'false'">
            <span>{{ data.source }}</span>
          </div>
          <div class="content-blk list-content-blk location-blk" v-if="isIndigo === 'false'">
            <span>{{ data.destination }}</span>
          </div>
          <!-- <div class="time-blk content-blk list-content-blk" v-if="isIndigo==='false'">
            <span>{{ getTime(data.pickUpTime, "pick") }}</span>
            <span>{{ getTimer(data.pickUpTime, "pick") }}</span>
          </div> -->

          <div class="time-blk content-blk list-content-blk" v-if="isIndigo === 'false'">
            <!-- <span v-if="data.serviceType === 1">{{ getTime(data.reportingTime, "drop") }}</span>
            <span v-if="data.serviceType === 1">{{ getTimer(data.reportingTime, "drop") }}</span>
            <span v-else> - </span> -->
            <span>{{ formatDecStyle(data.pickUpTime) }}</span>
          </div>
          <div class="time-blk content-blk list-content-blk" v-if="isIndigo === 'false'">
            <span>
              <div v-for="(emp, i) in data.employees" :key="i">
                {{ formatDecStyle(emp.loginTime) }}
              </div>
            </span>
          </div>


          <div class="content-blk list-content-blk row-list-blk" v-if="isIndigo === 'true'">
            <div class="row-list" v-for="(employee, rowIndex) in data.employees" :key="rowIndex">
              <div class="crew-blk">
                <span>
                  <span>{{ employee.name }} - {{ employee.mobile }}</span
                  ><br />
                  <strong v-if="employee.crewId">Crew ID: {{ employee.crewId }} ( {{ employee.crewCategory }} )</strong><br />
                  <strong style="color: #000099" v-if="employee.flightInfo"> {{ checkFlightInfo(employee) }}</strong
                  ><br />
                  <strong style="color: #000099" v-if="employee.flightInfo"> {{ checkFlightDateAndTime(employee) }}</strong>
                </span>
              </div>
              <div class="crew-blk">{{ ` ${data.serviceType === 1 ? employee.address : data.source}` }}</div>
              <div class="crew-blk">{{ `${data.serviceType === 1 ? data.destination : employee.address}` }}</div>
              <!-- <div class="crew-blk">{{ data.serviceType === 1 ? `${getTime(data.reportingTime, "drop")} ${getTimer(data.reportingTime, "drop")}` : "---" }}</div>
              <div class="crew-blk">{{ `${getTime(data.reportingTime, "reporting")} ${getTimer(data.reportingTime, "reporting")}` }}</div> -->

              <div class="crew-blk time-column">
                {{
                  data.serviceType === 1
                    ? `${getFormattedDateTime(employee.reportingTime, "drop")}
                `
                    : "---"
                }}
              </div>
              <div class="crew-blk time-column">{{ `${getFormattedDateTime(employee.reportingTime, "reporting")} ` }}</div>

              <div class="crew-blk">{{ employee.siComment ? employee.siComment : "---" }}</div>
            </div>
          </div>

          <div class="category-blk list-content-blk" v-if="!isIndigo">
            <span>{{ data.category }}</span>
            <strong v-if="data.tripType">{{ data.tripType }}</strong>
          </div>
          <div class="driver-blk" v-if="tripType === 1">
            <div class="driver-action-blk">
              <v-autocomplete
                v-model="data.driver"
                placeholder="Driver name/Driver No/Vehicle No"
                dense
                hide-details
                :items="drivers"
                :search-input.sync="searchDrivers[index]"
                :filter="filterDriver"
                item-text="name"
                item-value="mobile"
                clearable
                @change="getDriverDetails(data, index)"
                v-if="tripType === 1 && data.colorStatus !== 'LastMinutesTrip'"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title v-text="item.name"></v-list-item-title>
                    <v-list-item-subtitle v-text="item.mobile"></v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
              <span v-if="data.driverDetails !== null">{{ data.driverDetails.name }} - {{ data.driverDetails.mobile }} - {{ data.vehicle }}</span>
              <div class="details-button-blk" v-if="data.colorStatus !== 'LastMinutesTrip' && (data.status.id === 4 || data.status.id === 5 || data.status.id === 6)">
                <v-btn x-small color="#a73817" @click="checkUnAssign(data, index)" v-if="data.status.id === 4">un-assign</v-btn>
              </div>
              <!-- <v-btn x-small color="blue" @click="startTrip(data, index)" v-if="!enableETS">Start Trip</v-btn> -->
            </div>

            <!-- <v-text-field v-model="data.driver" placeholder="Driver" label="Driver" dense outlined hide-details @input="getDriverDetails(data, index)" maxlength="10"></v-text-field> -->
          </div>
          <div class="time-blk content-blk list-content-blk" v-if="isIndigo==='true' && [0, 1].includes(tripType)">
            <strong>{{ data.tripStatus }}</strong>
          </div>
              <div class="time-blk content-blk list-content-blk" v-if="isIndigo==='false'">
            <strong>{{ data.status.name }}</strong>
          </div>
          <div class="reject-blk" v-if="!isIndigo">
            <v-btn color="green" text small title="Copy" @click="copyMessage(data)" class="whatsapp-blk"><i class="fab fa-whatsapp-square"></i></v-btn>
          </div>
          <div class="action-blk" v-if="tripType === 0">
            <div class="action-button" v-if="data.status.id < 4 && data.colorStatus !== 'LastMinutesTrip'">
              <v-tooltip bottom>
                <template v-slot:activator="{ attrs, on }">
                  <i class="fas fa-thumbs-up" v-bind="attrs" v-on="on" @click="approveTrip(data)"></i>
                </template>
                <span>Approve</span>
              </v-tooltip>
              <!-- <v-tooltip bottom>
                <template v-slot:activator="{ attrs, on }">
                  <i class="fas fa-thumbs-down" v-bind="attrs" v-on="on" @click="getTripInfo(data)"></i>
                </template>
                <span>Reject</span>
              </v-tooltip> -->
            </div>
            <div v-else>-</div>
          </div>
          <div class="action-blk" v-if="tripType === 2">
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn small color="red" v-bind="attrs" v-on="on" text @click="approveCancel(data)"><i class="fas fa-thumbs-up"></i></v-btn>
              </template>
              <span>Approve Cancel</span>
            </v-tooltip>
          </div>
          <!-- <div class="action-blk" v-if="tripType === 3"></div> -->
        </div>
      </div>
      <div v-else class="no-trip-blk">
        <span>No Trips To Show</span>
      </div>
    </div>
    <div class="pagination">
      <!-- <v-pagination v-model="page" :length="1" :total-visible="4" @click="loadmore"></v-pagination> -->
      <v-pagination v-if="pageCount > 0" v-model="page" :length="Math.ceil(pageCount / pageSize)" @input="getTripData(filters)" :total-visible="6"></v-pagination>
    </div>
    <v-dialog v-model="assignDialog" width="800" persistent>
      <v-card>
        <DriverAssign
          :driverDetails="driverDetails"
          :bigId="bigId"
          @close-dialog="closeAssignDialog"
          v-if="assignDialog"
          :driverNumber="driverNumber"
          @assign-driver="driverAssign"
          :modelList="modelList"
          :currentCity="currentCity"
          :currentState="currentState"
          :tripDetails="tripDetails"
          @unassign="handleUnassign"
        ></DriverAssign>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addDialogStatus" width="800" persistent>
      <v-card>
        <DriverCabInsert
          @close-add-dialog="closeAddDialog"
          :driverNumber="driverNumber"
          :bigId="bigId"
          @assign-driver="driverCabAssign"
          :name="driverName"
          :disableStatus="disableStatus"
          :modelList="modelList"
          :currentCity="currentCity"
          :currentState="currentState"
          :tripDetails="tripDetails"
          v-if="addDialogStatus"
        >
        </DriverCabInsert>
      </v-card>
    </v-dialog>
    <v-navigation-drawer v-model="drawer" temporary width="1200" absolute>
      <TripDetails @closeTripDetails="handleDrawerClose" :tripId="tripId" v-if="drawer"></TripDetails>
    </v-navigation-drawer>
    <v-dialog width="500" v-model="dialogView">
      <v-card class="card-view-modal">
        <span>{{ message }}</span>
        <div class="card-button-blk">
          <v-btn small color="#eea004" @click="closeVendorDialog">OK</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="startDialog" width="650" persistent>
      <StartEndDialog @close-dialog="closeDialog" :bigId="statusBigId" @start-end-trip="startEndTrip" :status="status" v-if="startDialog"></StartEndDialog>
    </v-dialog>
    <Loading v-if="loading"></Loading>
    <Confirm ref="confirm"></Confirm>
    <v-dialog width="500" v-model="remarksModel">
      <DeactivationModal v-if="remarksModel" @callReject="rejectTrip" @dialog-closed="close" title="Reject" :show.sync="remarksModel" :onConfirm="rejectTrip"> </DeactivationModal>
    </v-dialog>

    <v-dialog width="1100" v-model="unclubDialog" persistent>
      <TripUnClubbing :tripDetails="tripDetails" @close-dialog="closeUnClubbingDialog" @check-unassign="unclubTrip" @submit-unclub="submitUnclub"></TripUnClubbing>
    </v-dialog>
  </div>
</template>

<script>
import Filters from "@/components/common/filter/Filters";
import axios from "@/axios/axios-global";
import * as moment from "moment";
import DriverAssign from "@/components/assign/driver-assign/DriverAssign";
import DriverCabInsert from "@/components/assign/driver-cab-insert/DriverCabInsert";
import Loading from "@/components/common/Loading";
import TripDetails from "@/components/Trips/trip-details/TripDetails";
import Confirm from "@/components/common/Confirm";
import StartEndDialog from "@/components/Trips/trips-view/StartEndDialog";
import DeactivationModal from "../../modal/DeactivationModal.vue";
import TripUnClubbing from "./TripUnClubbing.vue";
import XLSX from "xlsx";
export default {
  name: "ToBeAssigned",
  components: { Confirm, TripDetails, Loading, DriverCabInsert, DriverAssign, Filters, StartEndDialog, DeactivationModal, TripUnClubbing },
  props: {
    tripType: Number,
    tab: Number,
    selectedTab: String,
  },
  data() {
    return {
      remarksModel: false,
      tripList: [],
      tripId: 0,
      tripIndex: "",
      assignDialog: false,
      driverDetails: "",
      addDialogStatus: false,
      driverNumber: "",
      bigId: "",
      driverName: "",
      disableStatus: false,
      dialogView: false,
      loading: false,
      drawer: false,
      start: moment().format("YYYY-MM-DD"),
      end: moment().format("YYYY-MM-DD"),
      timeout: "",
      modelList: [],
      currentCity: 0,
      currentState: 0,
      filters: { start: moment().format("YYYY-MM-DD"), end: moment().format("YYYY-MM-DD"), time: "7", status: -1 },
      startDialog: false,
      statusBigId: 0,
      status: "",
      //    enableETS: "",
      rejectionReason: null,
      message: "",
      tripInfo: {},
      pageCount: 0,
      page: 1,
      pageSize: 50,

      drivers: [],
      defaultDrivers: [],
      searchDrivers: {},

      tripDetails: {},
      intervalId: null,

      unclubDialog: false,

      isExportDisabled: false,

      tripStatusColors: [
        { status: "LastMinutesTrip", color: "#F76A6A" },
        { status: "Confirmed", color: "#99FF99" },
        { status: "Rescheduled", color: "#FFBF00" },
        { status: "SpAssigned", color: "#F8ECEC" },
      ],
    };
  },
  mounted() {
    this.getTripData({ start: this.start, end: this.end, time: "7", status: -1 });
    this.$refs.tripList.scrollTo({ top: 0, behavior: "smooth" });
    this.getAssignFilters();
    //   this.enableETS = JSON.parse(localStorage.getItem("enableETS"));
    this.intervalId = setInterval(() => {
      this.getTripData(this.filters);
    }, 180000);
  },
  beforeDestroy() {
    if (this.intervalId) clearInterval(this.intervalId);
  },
  page() {
    this.getTripData(this.filters);
    this.$refs.tripList.scrollTo({ top: 0, behavior: "smooth" });
  },
  computed: {
     isIndigo() {
    return localStorage.getItem('isIndigo')
  },
     computedPlaceholder() {
    if (this.selectedTab === "To be Approved") {
      return this.$isIndigo==='true'
        ? "Trip ID/Flight No/Crew ID/Crew Name"
        : "Trip ID/ Name /Mobile";
    } else {
      return this.$isIndigo==='true'
        ? "Trip ID/Flight No/Crew ID/Crew Name/Driver/ Vehicle"
        : "Trip ID/ Name /Mobile";
    }
    },

    totalPages() {
      return this.pageSize > 0 ? Math.ceil(this.pageCount / this.pageSize) : 1;
    },
  },
  watch: {
    searchDrivers: {
      handler(value) {
        Object.keys(value).forEach((index) => {
          if (value[index] && value[index].length >= 3) {
            this.fetchDriversByNameOrNumber(value[index]);
          } else {
            this.drivers = [...this.defaultDrivers];
          }
        });
      },
      deep: true,
    },
    tripType() {
      this.tripList = [];
      this.resetInterval();
      this.page = 1;
      this.getTripData({ start: this.start, end: this.end, time: "7", status: -1 });
      this.$refs.tripList.scrollTo({ top: 0, behavior: "smooth" });
    },
    filters() {
      this.resetInterval();
    },
  },

  methods: {
    formatDecStyle(timestamp) {
      if (!timestamp) return "--";

      const date = new Date(Number(timestamp));

      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      const month = months[date.getMonth()];
      const day = date.getDate();

      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");

      return `${month} ${day} ${hours}:${minutes}`;
    },
    async handleUnassign(data) {
      try {
        this.loading = true;
        const response = await axios.post("trip/unassign", { tripid: data.bigId });
        if (response.status === 200) {
          this.reloadData();
          this.loading = false;
          this.unclubDialog = false;
          const index = this.tripList.findIndex((trip) => trip.bigId === data.bigId);
          if (index !== -1) {
            this.tripList[index].driverDetails = null;
            this.tripList[index].status = { id: 2, status: "Approved" };
            this.loading = false;
          }
        }
      } catch (error) {
        this.loading = false;
      }
    },
    async getDefaultDriverList() {
      try {
        const response = await axios.get("driver/default/list");
        if (response.status === 200) {
          this.defaultDrivers = response.data;
          this.drivers = [...this.defaultDrivers];
        } else {
          this.drivers = [];
          this.defaultDrivers = [];
        }
      } catch (error) {
        console.log(error);
      }
    },
    resetInterval() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.intervalId = setInterval(() => {
        this.getTripData(this.filters);
      }, 180000);
    },
    async fetchDriversByNameOrNumber(value) {
      try {
        const payload = { searchQuery: value };
        const response = await axios.post("trip/driver/search", payload);
        if (response.status === 200 && response.data.result.length > 0) {
          this.drivers = [...response.data.result];
        } else {
          this.drivers = [...this.defaultDrivers];
        }
      } catch (error) {
        this.drivers = [...this.defaultDrivers];
        console.log(error);
      }
    },
    close() {
      this.remarksModel = false;
    },
    handleDrawerClose() {
      this.drawer = false;
    },
    getFilters(data) {
      this.filters = data;
      this.page = 1;
      this.getTripData(this.filters);
      this.$refs.tripList.scrollTo({ top: 0, behavior: "smooth" });
      this.$emit("get-all-filters", this.filters);
    },
    async getAssignFilters() {
      const response = await axios.get("settings/model/list");
      this.modelList = response.data;
    },
    async getTripData(data) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(async () => {
        this.loading = true;
        const payload = {
          state: data.state,
          search: data.searchValue ? data.searchValue : "",
          flightNo: data.searchValue ? data.searchValue : "",
          city: data.city,
          startDate: data.start,
          endDate: data.end,
          time: data.time,
          date: data.date,
          branch: data.branch,
          page: this.page,
          limit: this.pageSize,
          acceptedTrips: this.tripType !== 0 ? true : false,
          cancellation: this.tripType === 2 ? 0 : this.tripType === 3 ? 1 : undefined,
          status: data.status,
          serviceType: data.serviceType,
        };
        const response = await axios.post("/trip/toAssign", payload);
        this.loading = false;
        this.tripList = response.data.list;
        this.pageCount = response.data.total;
        this.tripList = this.tripList.map((data) => {
          return { ...data, driver: "" };
        });
        if (this.tripList.length > 0) {
          // console.log(this.$refs.tripList.scrollHeight)
          //  this.sortData(this.tripList);
          if (this.tripType === 1) {
            this.getDefaultDriverList();
          }
        }
      }, 500);
    },

    copyMessage(data) {
      let text = "";
      if (data.driverDetails !== null) {
        text = `Customer Name: ${data.user}\nMobile: ${data.mobile}\nLocation: ${data.source}\nTime: ${moment(data.pickUpTime, "x").format("DD-MM-YYYY LT")}\nBranch: ${data.branch}\nDriver: ${
          data.driverDetails.name
        }\nDriver Mobile: ${data.driverDetails.mobile}\nCar No.: ${data.vehicle}`;
      } else {
        text = `Customer Name: ${data.user}\nMobile: ${data.mobile}\nLocation: ${data.source}\nTime: ${moment(data.pickUpTime, "x").format("DD-MM-YYYY LT")}\nBranch: ${data.branch}`;
      }
      const el = document.createElement("textarea");
      el.value = text;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.$toasted.show("Details copied", {
        position: "bottom-center",
        duration: 3000,
      });
    },
    reloadData() {
      if (this.filters === "") {
        this.getTripData({ date: this.date });
        this.$refs.tripList.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        this.getTripData(this.filters);
        this.$refs.tripList.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
    getDateAndTime(date, format) {
      return date ? moment(date, format).format("DD-MM-YYYY HH:mm") : "";
    },

    getFormattedDateTime(data, type) {
      let dateTime = moment(data);

      if (type === "drop") {
        dateTime = dateTime.subtract(20, "minutes");
      }

      return dateTime.format("MMM DD HH:mm");
    },

    getTime(data, type) {
      if (type !== "drop") return moment(data, "x").format("MMM DD");
      else return moment(data, "x").subtract("20", "minutes").format("MMM DD");
    },
    getTimer(data, type) {
      if (type !== "drop") return moment(data, "x").format("HH:mm");
      else return moment(data, "x").subtract("20", "minutes").format("HH:mm");
    },
    // sortData(data) {
    //  data.sort((a, b) => {
    //   return (a.driverDetails !== null) - (b.driverDetails !== null) || -(a > b) || +(a < b);
    //  });
    // },
    async getDriverDetails(data, index) {
      if (data && data.driver && data.driver.length === 10) {
        this.drivers = [...this.defaultDrivers];
        this.tripId = data.bigId;
        this.tripIndex = index;
        this.bigId = data.bigId;
        this.tripDetails = data;
        this.loading = true;
        const response = await axios.post("trip/driver/details", { mobile: data.driver, tripId: data.bigId });
        this.loading = false;

        
        if (response.data.driverDetails) {
          if (response.data.driverDetails.trash) {
            this.message = "This driver is Inactive";
            return (this.dialogView = true);
          }
          this.driverNumber = data.driver;
          if (response.data.message !== "No driver exist in this number" && response.data.message !== "No vehicle assigned") {
            this.assignDialog = true;
            this.driverDetails = response.data.driverDetails;
            this.currentCity = response.data.currentCity;
            this.currentState = response.data.currentState;
          } else {
            this.dialogView = true;
            this.driverNumber = data.driver;
            this.message = response.data.message;
          }
        } else if (response.data.message === "No driver exist in this number") {
          this.dialogView = true;
          this.driverNumber = data.driver;
          this.message = response.data.message;
        } else if (response.data.message === "Driver exists for another servicePartner") {
          this.dialogView = true;
          this.driverNumber = data.driver;
          this.message = "Driver exists for another vendor, please contact taSki to assign the trip to this driver";
        } else if (response.data.message === "Driver exists for another Branch") {
          this.dialogView = true;
          this.driverNumber = data.driver;
          this.message = "Driver exists for another Branch";
        }
      }
    },
    showDetails(data) {
      this.drawer = true;
      this.tripId = data;
    },
    driverAssign(data) {
      this.assignDialog = false;
      this.drivers = [...this.defaultDrivers];
      this.getTripData(this.filters);
      //    this.tripList[this.tripIndex].driverDetails = { name: data.name, mobile: data.number };
      //    this.tripList[this.tripIndex].vehicle = data.vehicleNo;
      //    this.assignDialog = false;
      //    this.tripList[this.tripIndex].driver = "";
      //    this.tripList[this.tripIndex].status = { id: 4, status: "Driver Assigned" };
      //    this.sortData(this.tripList);
    },
    submitUnclub() {
      this.unclubDialog = false;
      this.getTripData(this.filters);
    },
    driverCabAssign(data) {
      this.tripList[this.tripIndex].driverDetails = { name: data.name, mobile: data.number };
      this.tripList[this.tripIndex].vehicle = data.vehicleNo;
      this.addDialogStatus = false;
      this.tripList[this.tripIndex].driver = "";
      this.tripList[this.tripIndex].status = { id: 4, status: "Driver Assigned" };
      //  this.sortData(this.tripList);
    },
    closeAssignDialog() {
      this.assignDialog = false;
      this.drivers = [...this.defaultDrivers];
      this.tripList[this.tripIndex].driver = "";
    },
    closeAddDialog() {
      this.addDialogStatus = false;
      this.drivers = [...this.defaultDrivers];
      this.tripList[this.tripIndex].driver = "";
    },
    closeVendorDialog() {
      this.dialogView = false;
      const index = this.tripList.findIndex((data) => data.driver === this.driverNumber);
      if (index !== -1) {
        this.tripList[index].driver = "";
      }
    },
    closeUnClubbingDialog() {
      this.unclubDialog = false;
      this.tripDetails = {};
    },

    checkUnAssign(data) {
      if (this.$isIndigo === "true" && data.employees.length > 1) {
        this.unclubDialog = true;
        this.tripDetails = data;
      } else {
        this.usAssignDriver(data);
      }
    },

    unclubTrip(crewIds) {
      this.usAssignDriver(this.tripDetails, crewIds);
    },
    async usAssignDriver(data, crewIds) {
      let confirmTitle = "Confirm Un-Assign";
      let confirmText = "Please confirm to Un-Assign this Driver";
      if (await this.$refs.confirm.open(confirmTitle, confirmText, {})) {
        this.loading = true;
        try {
          const response = await axios.post("trip/unassign", { tripid: data.bigId, crewId: crewIds });
          if (response.status === 200) {
            this.reloadData();
            this.loading = false;
            if (crewIds) this.unclubDialog = false;
            const index = this.tripList.findIndex((trip) => trip.bigId === data.bigId);
            if (index !== -1) {
              this.tripList[index].driverDetails = null;
              this.tripList[index].status = { id: 2, status: "Approved" };
              this.$toasted.show(response.data.message, {
                position: "bottom-center",
                duration: 4000,
              });
              this.loading = false;
            }
          }
        } catch (error) {
          this.loading = false;
        }
      }
    },
    startTrip(data, index) {
      this.startDialog = true;
      this.statusBigId = data.bigId;
      if (data.status.id === 4 || data.status.id === 5 || data.status.id === 6) {
        this.status = "Start";
      }
    },
    closeDialog() {
      this.startDialog = false;
    },
    startEndTrip(data) {
      const index = this.tripList.findIndex((trip) => trip.bigId === data.id);
      if (index !== -1) {
        this.tripList.splice(index, 1);
      }
      this.startDialog = false;
    },
    getTripInfo(data) {
      this.remarksModel = !this.remarksModel;
      this.tripInfo.tripId = data.bigId;
      this.tripInfo.status = data.status.id;
    },
    async rejectTrip(remarks) {
      this.loading = true;
      try {
        let payload = {
          tripId: this.tripInfo.tripId,
          status: this.tripInfo.status,
          sp: localStorage.getItem("vendorName"),
          remarks: remarks,
        };
        const response = await axios.post("/trip/reject", payload);
        if (response.status === 200) {
          this.remarksModel = false;
          this.loading = false;
          this.$toasted.show(response.data, {
            position: "bottom-center",
            duration: 4000,
          });
          this.reloadData();
        } else {
          this.loading = false;
          this.$toasted.show(response.data, {
            position: "bottom-center",
            duration: 4000,
          });
        }
      } catch (error) {
        this.loading = false;
        this.$toasted.show(error.response.data, {
          position: "bottom-center",
          duration: 4000,
        });
      }
    },
    async approveTrip(trip) {
      let confirmTitle = "Confirm Approve";
      let confirmText = "Please confirm to approve this trip";
      if (await this.$refs.confirm.open(confirmTitle, confirmText, {})) {
        this.loading = true;
        try {
          const payload = {
            tripid: trip.bigId,
          };
          const response = await axios.post("trip/approve", payload);
          this.loading = false;
          if (response.status === 200) {
            this.$toasted.show(response.data, {
              position: "bottom-center",
              duration: 4000,
            });
            this.reloadData();
          } else {
            this.$toasted.show(response.data, {
              position: "bottom-center",
              duration: 4000,
            });
          }
        } catch (error) {
          this.loading = false;
          this.$toasted.show(error.response.data, {
            position: "bottom-center",
            duration: 4000,
          });
        }
      }
    },
    async approveCancel(trip) {
      let confirmTitle = "Approve Cancellation";
      let confirmText = "Please confirm your approval to cancel this trip";
      if (await this.$refs.confirm.open(confirmTitle, confirmText, {})) {
        this.loading = true;
        try {
          const payload = {
            tripid: trip.bigId,
          };
          const response = await axios.post("trip/cancellationApproval", payload);
          this.loading = false;
          if (response.status === 200) {
            this.$toasted.show(response.data, {
              position: "bottom-center",
              duration: 4000,
            });
            this.reloadData();
          } else {
            this.$toasted.show(response.data, {
              position: "bottom-center",
              duration: 4000,
            });
          }
        } catch (error) {
          this.loading = false;
          this.$toasted.show(error.response.data, {
            position: "bottom-center",
            duration: 4000,
          });
        }
      }
    },
    filterDriver(item, queryText, itemText) {
      if (queryText.length >= 3)
        return (
          (item && item.name && item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1) ||
          (item && item.search && item.search.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1) ||
          (item && item.mobile && item.mobile.toString().indexOf(queryText) > -1)
        );
    },
   checkFlightInfo(item) {
      const flightInfo = item && item.flightInfo; 
      if (!flightInfo || typeof flightInfo !== 'string') {
        return '';
      }
      return flightInfo.replace(
        /.*Flight No:(\S+)(?:.*?at (\S+) from (\S+)|.*?from (\S+) to (\S+))/,
        (_, flightNo, at1, from1, from2, to2) => {
          if (at1 && from1) return `${flightNo} ${at1} - ${from1}`;
          if (from2 && to2) return `${flightNo} ${from2} - ${to2}`;
          return flightNo;
        }
      );
    },


    exportFlightInfo(item) {
      const info = item.flightInfo || "";
      let match = info.match(/Flight No:(\S+).*?(?:on|at)?\s*(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2}).*?from (\S+) to (\S+)/);
      if (match) {
        const [, flightNo, date, time, from, to] = match;
        return `${flightNo} on ${date} ${time} - ${from} → ${to}`;
      }

      match = info.match(/Flight No:(\S+).*?(?:on|at)?\s*(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2}).*?at (\S+) from (\S+)/);

      if (match) {
        const [, flightNo, date, time, at, from] = match;
        return `${flightNo} on ${date} ${time} - ${from} → ${at}`;
      }
      match = info.match(/(ASBD|ADSB|ASBS).*?(?:on|at)?\s*(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2})\s+at\s+(\S+)/);
      if (match) {
        const [, code, date, time, at] = match;
        return `${code} on ${date} ${time} - ${at}`;
      }

      return info;
    },


    checkFlightDateAndTime(item) {
      const match = item.flightInfo.match(/\d{4}-\d{2}-\d{2} \d{2}:\d{2}/);
      if (match) {
        const dateTimeStr = match[0]; // "2025-06-07 11:50"
        const [date, time] = dateTimeStr.split(" ");
        return `${date} ${time}`;
      } else {
        return null;
      }
    },
    async exportToExcel() {
      if (this.tripList.length === 0) {
        this.$toasted.show("No data available to export", {
          position: "bottom-center",
          duration: 3000,
        });
        return;
      }
      const payload = {
        state: this.filters.state,
        search: this.filters.searchValue ? this.filters.searchValue : "",
        flightNo: this.filters.searchValue ? this.filters.searchValue : "",
        city: this.filters.city,
        startDate: this.filters.start,
        endDate: this.filters.end,
        time: this.filters.time,
        date: this.filters.date,
        branch: this.filters.branch,
        acceptedTrips: this.tripType !== 0 ? true : false,
        cancellation: this.tripType === 2 ? 0 : this.tripType === 3 ? 1 : undefined,
        status: this.filters.status,
        serviceType: this.filters.serviceType,
      };
      this.isExportDisabled = true;
      const exportUrl = this.tripType === 1 ? "/trip/exportToBeAssign" : "/trip/exportToBeApprove";
      const response = await axios.post(exportUrl, payload);
      const allTrips = response.data.list;
      this.isExportDisabled = false;

      const exportData = allTrips.map((trip, index) => {
        const row = {
          "Sl No": index + 1,
          "Trip ID": trip.id ? trip.id : trip.bigId,
          "Service Type": [1, 2].includes(trip.serviceType) ? (trip.serviceType === 1 ? "Pickup" : "DropOff") : "",
        };

        if (!this.$isIndigo) {
          row["User"] = trip.user || "";
          row["Mobile"] = trip.mobile || "";
          row["Source"] = trip.source || "";
          row["Destination"] = trip.destination || "";
          row["PickUp Time"] = trip.pickUpTime ? this.getTime(trip.pickUpTime, "pick") + " " + this.getTimer(trip.pickUpTime, "pick") : "";
          row["Reporting Time"] = trip.reportingTime ? this.getTime(trip.reportingTime, "reporting") + " " + this.getTimer(trip.reportingTime, "reporting") : "";
          row["Category"] = trip.category || "";
          row["Trip Type"] = trip.tripType || "";
        } else {
          row["Crew ID"] = trip.employees ? trip.employees.map((emp) => emp.crewId || "---").join("; ") : "";
          row["Crew Name"] = trip.employees ? trip.employees.map((emp) => emp.name || "---").join("; ") : "";
          row["Crew Mobile"] = trip.employees ? trip.employees.map((emp) => emp.mobile || "---").join("; ") : "";
          row["Flight No"] = trip.employees ? trip.employees.map((emp) => this.exportFlightInfo(emp)).join("; ") : "";
          // row["Crew Details"] = trip.employees
          //   ? trip.employees
          //       .map(
          //         (emp) =>
          //           `${emp.name} - ${emp.mobile}${emp.crewId ? ` (Crew ID: ${emp.crewId} - ${emp.crewCategory})` : ""}${
          //             emp.flightInfo ? ` (${this.checkFlightInfo(emp)})` : ""
          //           }`
          //       )
          //       .join("; ")
          //   : "";
          row["Pickup Address"] = trip.employees ? trip.employees.map((emp) => (trip.serviceType === 1 ? emp.address : trip.source)).join("; ") : trip.source || "";
          row["Drop Address"] = trip.employees ? trip.employees.map((emp) => (trip.serviceType === 1 ? trip.destination : emp.address)).join("; ") : trip.destination || "";
          row["Drop Off Time"] = trip.employees ? trip.employees.map((emp) => (trip.serviceType === 1 ? this.getFormattedDateTime(emp.reportingTime, "drop") : "---")).join("; ") : "";
          row["Reporting Time"] = trip.employees ? trip.employees.map((emp) => this.getFormattedDateTime(emp.reportingTime, "reporting")).join("; ") : "";
          row["SI Comment"] = trip.employees ? trip.employees.map((emp) => emp.siComment || "---").join("; ") : "";
        }

        if (this.tripType === 1) {
          row["Driver"] = trip.driverDetails && trip.driverDetails.name ? `${trip.driverDetails.name} - ${trip.driverDetails.mobile} - ${trip.vehicle || ""}` : "";
        }

        if (this.$isIndigo && [0, 1].includes(this.tripType)) {
          row["Status"] = trip.tripStatus || "";
        }

        return row;
      });

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Trips");
      const colWidths = Object.keys(exportData[0]).map((key) => Math.max(key.length, ...exportData.map((row) => (row[key] ? row[key].toString().length : 0))));
      worksheet["!cols"] = colWidths.map((width) => ({ wch: width + 2 }));

      XLSX.writeFile(workbook, `Trip_List_${moment().format("YYYYMMDD_HHmmss")}.xlsx`);
    },
    getStatusColor(status) {
      const found = this.tripStatusColors.find((s) => s.status.toLowerCase() === status.toLowerCase());
      return found ? found.color : "#fff"; // default gray
    },
  },
};
</script>

<style scoped lang="scss">
.pagination {
  display: block;
  //  position: sticky;
  bottom: 0;
  width: 100%;
  background: white;
  padding: 10px 0;
}

.assign-employee-list {
  ul {
    list-style-type: disc;
  }
  li {
    margin-top: 5px;
    strong {
      color: #096181c3;
    }

    &:first-child {
      margin-top: 0;
    }

    //   display: flex;
    //   flex-direction: column;
    //   list-style: disc;
  }

  .extra-details {
    display: flex;
    flex-direction: column;
    gap: 5px;
    b {
      color: #1f618c;
    }
  }
}

.action-button {
  display: flex;

  //  @media screen and (max-width: 1620px) {
  //   flex-direction: column;
  //  }
  //
  gap: 20px;
  .fas {
    cursor: pointer;
  }
  .fa-thumbs-up {
    color: green;
  }
  .fa-thumbs-down {
    color: rgb(188, 8, 8);
  }
}
// .si-comment-list {
//   list-style-type: none;
//   margin: 0;
//   padding: 0;
//   li {
//     margin-bottom: 5px;
//     font-size: 12px;
//     color: #333;
//     white-space: nowrap;
//     overflow: hidden;
//     text-overflow: ellipsis;
//     max-width: 100%;
//   }
// }

.si-comment-text {
  color: #0b0b0e;
  font-weight: bold;
  font-family: 0.3rem;
  text-transform: capitalize;
}
.export-btn {
  margin-left: 10px;
}
@import "./tobeAssigned.scss";
</style>
